function get_contrato_vacio() {
    return {
        clave: '',
        contrato_pdf: '',
        detalles_servicio: '',
        envio_correo: 0,
        fecha_creacion: '',
        fecha_mudanza: '',
        folio_carta_porte: '',
        id: '',
        id_carta_porte: '',
        id_cotizacion_contratada: '',
        id_crm: '',
        id_mm: '',
        nota_proveedor: '',
        precio: null
    };
}
export { get_contrato_vacio };
